var map = {
	"./01_manzoni_High.avif": 42086,
	"./01_manzoni_High.png": 36766,
	"./Bembo_High.avif": 92561,
	"./Bembo_High.png": 12228,
	"./dante.avif": 89442,
	"./dante.png": 6436
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77207;